import React from 'react';
import { __ } from '@wordpress/i18n';
//import { useNavigate } from 'react-router-dom';
import { head } from 'ramda';

// store
import { useStoreValue } from '../../store';

// components
import AllDomandeBeneficiarioTableAsync from '../DomandeBeneficiario/components/AllDomandeBeneficiarioTableAsync';
import ErrorBoundary from '../../components/ErrorBoundary';
import MyLatestSubmissionsTableAsync from '../DashboardBeneficiario/components/MyLatestSubmissionsTableAsync';

const Imieibandi = () => {
    //const navigate = useNavigate();
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const companies = useStoreValue('companies');
    const company = head(companies.filter(o => o.id === chosenCompanyId));

    /*const gotToBandiDisponibili = () => {
        navigate('/moduli')
    }*/

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Questionario ESG', 'htr')}</h1>
                {company ? <span className="companyName">{company.companyName}</span> : null}
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('In Lavorazione', 'htr')}</h2>
                <ErrorBoundary><MyLatestSubmissionsTableAsync/></ErrorBoundary>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('In Attesa Approvazione', 'htr')}</h2>
                <AllDomandeBeneficiarioTableAsync statuses={['SOCCORSO', 'APPROVED', 'REJECTED', 'EVALUATION', 'SUBMIT',
                    'APPOINTMENT', 'NDG', 'ADMISSIBLE', 'AWAITING_TECHNICAL_EVALUATION', 'TECHNICAL_EVALUATION']}/>
            </div>

            {/*<div className="appPageSection__hr">
                <span>{__('Azioni rapide', 'htr')}</span>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <div className="appPageSection__actions">
                    <Button
                        onClick={gotToBandiDisponibili}
                        label={__('Form disponibili', 'htr')} icon="pi pi-bookmark" iconPos="right"/>
                    <Button
                        disabled={true}
                        outlined
                        onClick={() => {
                        }}
                        label={__('Contatta assistenza', 'htr')} icon="pi pi-envelope" iconPos="right"/>
                </div>
            </div>*/}
        </div>
    )
}

export default Imieibandi;